/**
 * Weddinsite — traditional wedding monogram logo.
 * Combines: Indian peacock motif suggestion + ornate wreath circle + paisley tail.
 */
export default function WeddinsiteLogo({ size = 32, color = "#1A1918", accent = "#B89B5E", className = "" }) {
  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <svg width={size} height={size} viewBox="0 0 64 64" className="shrink-0">
        {/* outer ornate circle */}
        <circle cx="32" cy="32" r="30" fill="none" stroke={accent} strokeWidth="0.8" />
        <circle cx="32" cy="32" r="26" fill="none" stroke={accent} strokeWidth="0.4" />
        {/* dotted ring */}
        {Array.from({ length: 24 }).map((_, i) => {
          const a = (i / 24) * Math.PI * 2;
          return <circle key={i} cx={32 + Math.cos(a) * 28} cy={32 + Math.sin(a) * 28} r="0.6" fill={accent} />;
        })}
        {/* central paisley / mandala */}
        <g transform="translate(32 32)" fill="none" stroke={color} strokeWidth="1" strokeLinecap="round">
          <path d="M -10 4 Q -4 -10 0 -10 Q 4 -10 10 4 Q 4 10 0 10 Q -4 10 -10 4 Z" fill={color} fillOpacity="0.9" />
          <path d="M 0 -10 Q -2 -3 0 0 Q 2 -3 0 -10 Z" fill={accent} />
          {/* petals */}
          {[0, 60, 120, 180, 240, 300].map((d, i) => (
            <path key={i} d="M 0 -8 q -2 -3 0 -6 q 2 3 0 6" transform={`rotate(${d})`} stroke={accent} strokeWidth="0.6" />
          ))}
        </g>
        {/* tiny crown dots */}
        <circle cx="32" cy="6" r="1.2" fill={accent} />
        <circle cx="32" cy="58" r="1.2" fill={accent} />
        <circle cx="6" cy="32" r="1.2" fill={accent} />
        <circle cx="58" cy="32" r="1.2" fill={accent} />
      </svg>
      <span className="flex flex-col leading-none">
        <span className="font-serif-display text-[1.5rem] tracking-tight" style={{ color }}>Weddinsite</span>
        <span className="text-[8px] tracking-[0.4em] uppercase mt-0.5" style={{ color: accent }}>Invitations · Est. 2026</span>
      </span>
    </span>
  );
}
